/**
 * Returns the full path to the rights-management-page of a specific installation
 */
export const getRightsManagementRoute = (installationId = ':installationId', activeStorage?: string): string => {
  if (activeStorage) {
    return `/dashboard/rights-administration/${installationId}/${activeStorage}`
  }
  return `/dashboard/rights-administration/${installationId}`
}
